import axios from 'axios';

/**
 * 写真操作履歴取得
 */
export const getPictureLogs = (param?: string) => {
  let url = '/api/v1/picturelogs/';
  if (param) {
    url += '?' + param;
  }
  return axios
    .get(url, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
